<template>
    <div class="relative min-h-80">
        <loading
            class="mt-40 md:mt-48 h-32"
            :active.sync="isLoading"
            :can-cancel="false"
            :is-full-page="false"
        />
        <div class="md:mt-16 mt-8 px-4 md:px-2" v-if="!isLoading">
            <form class="w-full md:px-2" ref="form">
                <div
                    class="
                        container
                        hidden
                        md:flex
                        flex-wrap
                        py-2
                        px-2
                        justify-between
                    "
                >
                    <div
                        :class="
                            filterDesignation === designation.value
                                ? 'font-serif'
                                : 'font-serif-300'
                        "
                        class="w-full md:w-auto p-1 text-base"
                        v-for="designation in data.designation"
                        :key="designation.value"
                    >
                        <input-radio
                            v-model="filterDesignation"
                            :name="'designation'"
                            :value="designation.value"
                            :id="designation.value"
                            :description="designation.label"
                        ></input-radio>
                    </div>
                </div>
                <div class="flex md:hidden flex-wrap -mx-4 md:-mx-2">
                    <div class="w-full js-team" ref="select">
                        <v-select
                            :clearable="false"
                            :options="data.designation"
                            :reduce="
                                filterDesignation => filterDesignation.value
                            "
                            v-model="filterDesignation"
                            label="label"
                        ></v-select>
                    </div>
                </div>
            </form>
            <section
                class="js-section"
                v-for="area in data.area"
                :key="area.value"
            >
                <div
                    class="
                        gridWrap
                        container
                        py-4
                        px-4
                        mt-4
                        md:mt-16
                        mb-0
                        md:mb-4
                    "
                >
                    <h2 class="text-center">
                        <span
                            class="
                                border-t-6 border-b-6 border-transparent
                                hover:border-brand
                                js-step
                            "
                            >{{ area.label }}</span
                        >
                    </h2>
                </div>
                <div
                    class="
                        mx-auto
                        md:flex
                        md:content-center
                        md:flex-wrap
                        md:justify-center
                        py-2
                        px-2
                        container
                    "
                >
                    <div
                        class="gridElement py-2 px-2 w-full md:w-1/2 lg:w-1/3"
                        v-for="(item, index) in filterByValue(
                            filteredEntries,
                            area.value,
                        )"
                        :key="index"
                    >
                        <article
                            class="
                                flex-1
                                h-96
                                md:h-128
                                w-full
                                group
                                relative
                                overflow-hidden
                            "
                        >
                            <image-src-set
                                v-if="item.images"
                                :webp-src-set="item.images.webP"
                                :jpg-src-set="item.images.jpg"
                                classes="w-full h-96 md:h-128 lazyload"
                                :alt="item.imageTitle"
                            ></image-src-set>
                            <div
                                class="
                                    articleWrap
                                    absolute
                                    top-0
                                    bottom-0
                                    mt-68
                                    md:mt-0
                                    group-hover:transform-up
                                    bg-brand-50
                                    md:bg-transparent
                                    md:group-hover:bg-brand-50
                                    transform-down-5
                                    w-full
                                    h-96
                                    md:h-128
                                "
                            >
                                <div class="articleContainer">
                                    <div
                                        class="
                                            articleInner
                                            absolute
                                            top-0
                                            flex flex-col
                                            text-left
                                            overflow-hidden
                                            h-full
                                            w-full
                                            py-3
                                            px-4
                                            md:justify-center
                                            ease-in-out
                                            duration-200
                                        "
                                    >
                                        <div class="articleBody">
                                            <h3
                                                class="
                                                    mb-0
                                                    font-serif
                                                    text-xl text-white
                                                    md:mt-12
                                                "
                                            >
                                                {{ item.title }}
                                            </h3>
                                            <p
                                                class="
                                                    text-lg text-white
                                                    mt-auto
                                                    md:mt-4
                                                    font-sans
                                                "
                                            >
                                                {{ item.type }}
                                            </p>
                                            <a
                                                class="
                                                    hidden
                                                    md:block
                                                    text-lg text-white
                                                    mt-2
                                                    font-sans
                                                "
                                                :href="'mailto:' + item.email"
                                                >{{ item.email }}</a
                                            >
                                            <a
                                                class="
                                                    hidden
                                                    md:block
                                                    text-lg text-white
                                                    font-sans
                                                "
                                                :href="'tel:' + item.phone"
                                                >{{ item.phone }}</a
                                            >
                                        </div>
                                    </div>

                                    <button
                                        @click="openModal(item)"
                                        class="
                                            absolute
                                            px-4
                                            py-3
                                            mt-16
                                            md:bottom-0
                                            text-white
                                            font-sans
                                            text-lg
                                        "
                                    >
                                        <span class="mr-2">></span>mehr
                                    </button>
                                </div>
                            </div>
                        </article>
                    </div>
                    <modal
                        v-if="modalVisible"
                        @close="modalVisible = false"
                        :data="modalData"
                    >
                    </modal>
                </div>
                <div
                    class="
                        gridWrap
                        container
                        py-4
                        px-4
                        mt-4
                        md:mt-16
                        flex
                        justify-center
                    "
                >
                    <hr
                        class="bg-grey-darkest h-px opacity-25 w-3/5 mb-0 mt-0"
                    />
                </div>
            </section>
        </div>
    </div>
</template>

<script>
/* eslint-disable vue/script-indent */

import Loading from 'vue-loading-overlay';
import { mapActions, mapState, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import debounce from 'lodash/debounce';
import getCurrentLanguage from '../../helpers/getCurrentLanguage.js';
import stopBodyScrolling from '../../helpers/stopBodyScrolling.js';
import InputRadio from './input/InputRadio.vue';
import ImageSrcSet from './image/ImageSrcSet.vue';
import Modal from './Modal.vue';

export default {
    name: 'Team',
    components: { Loading, Modal, InputRadio, ImageSrcSet },
    props: {
        data: Object,
    },
    data() {
        return {
            modalVisible: false,
            modalData: null,
        };
    },
    async created() {
        await this.setMutation({
            mutation: 'SET_CURRENT_VIEW',
            value: this.data.currentView,
        });
        await this.setMutation({ mutation: 'SET_IS_LOADING', value: true });
        await this.axiosGet({
            mutation: 'SET_ENTRIES',
            api: `${getCurrentLanguage()}/api/${this.data.api}`,
        });
        await this.setMutation({ mutation: 'SET_IS_LOADING', value: false });
    },
    mounted() {
        this.handleDebouncedScroll = debounce(this.handleScroll, 1);
        window.addEventListener('scroll', this.handleDebouncedScroll);
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.handleDebouncedScroll);
    },
    watch: {
        modalVisible(val) {
            stopBodyScrolling(val);
        },
    },
    methods: {
        ...mapActions(['axiosGet', 'setMutation']),
        filterByValue(array, string) {
            return array.filter(item => item.area === string);
        },
        openModal(data) {
            this.modalData = data;
            this.modalVisible = true;
        },
        // eslint-disable-next-line no-unused-vars
        handleScroll(event) {
            this.$nextTick(() => {
                if (
                    !this.isLoading &&
                    this.$refs.form.getBoundingClientRect().y <= 64
                ) {
                    this.$refs.select.classList.add(
                        'animated-team',
                        'fixed',
                        'top-0',
                        'left-0',
                        'z-50',
                    );
                } else if (
                    !this.isLoading &&
                    this.$refs.form.getBoundingClientRect().y > 64
                ) {
                    this.$refs.select.classList.remove(
                        'animated-team',
                        'fixed',
                        'top-0',
                        'left-0',
                        'z-50',
                    );
                }
            });
        },
    },
    computed: {
        ...mapState(['entries', 'pagination', 'isLoading']),
        ...mapGetters(['filteredEntries']),
        ...mapFields(['filter.filterDesignation']),
    },
};
</script>
